import { CircularProgress } from "@mui/material";
import {FlexBox} from "@/styles/layout/boxes";
import {FC} from "react";

const Loader: FC = () => {
  return (
    <FlexBox sx={{width: '100%', height: '100%', justifyContent: 'center'}}>
        <CircularProgress sx={{color: '#5959F3'}}/>
    </FlexBox>
  );
};

export default Loader;
